import { LocationSearchValue } from '@components/location-search/location-search';
import { toQueryString } from '@utils/requests';

import { unhandledRequest } from '../request';

export type Translation = {
  title: string;
  language: string;
};

export type LocationList = {
  count: number;
  next?: string;
  previous?: string;
  results: Location[];
};

export type Location = {
  address?: string;
  externalId?: string;
  id: number;
  latitude?: number;
  longitude?: number;
  numJobs: number;
  translations: Translation[];
  isActive?: boolean;
};

export async function mapToken() {
  const response = await unhandledRequest.get<{ token: string }>({
    url: '/settings/map-token/',
  });
  return response.data;
}

export async function list(limit: number, offset: number, search: string, isActive?: boolean) {
  const query = toQueryString({
    limit: limit ?? 50,
    offset: offset ?? 0,
    search: search ?? '',
    ...(isActive !== undefined ? { is_active: isActive } : {}),
  });
  const response = await unhandledRequest.get<LocationList>({
    url: '/v1/locations/' + query,
  });
  return response.data;
}

export async function counts(search: string) {
  const query = toQueryString({
    search: search ?? '',
  });
  const response = await unhandledRequest.get<{ activeCount: number; inactiveCount: number }>({
    url: '/v1/locations/counts/' + query,
  });
  return response.data;
}

export async function create(
  externalId: string,
  translations: Translation[],
  location: LocationSearchValue | null,
  isActive?: boolean,
) {
  const response = await unhandledRequest.post<Location>({
    url: '/v1/locations/',
    data: {
      translations,
      externalId,
      address: location?.address,
      latitude: location?.latitude,
      longitude: location?.longitude,
      isActive,
    },
  });
  return response.data;
}

export function edit(
  locationId: number,
  externalId: string,
  translations: Translation[],
  location: LocationSearchValue | null,
  isActive?: boolean,
) {
  return unhandledRequest.patch({
    url: `/v1/locations/${locationId}/`,
    data: {
      translations,
      externalId,
      address: location?.address,
      latitude: location?.latitude,
      longitude: location?.longitude,
      isActive,
    },
  });
}

export function deleteLocation(locationId: number) {
  return unhandledRequest.delete({ url: `/v1/locations/${locationId}/` });
}
